import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useState } from "react";
import { RiverDetails } from "../riverSensors/RiverSensors";

// Define the context type
type RiverContextType = {
  RiverOpenSidebarMap: Map<string, RiverDetails>;
  setRiverOpenSidebarMap: (type: string, ewsopenMap: RiverDetails) => void;
  removeFromRiverOpenSidebarMap: (active_pcode: string) => void;
  clearRiverOpenSidebarMap: () => void;
  clickedRiverString: string | null;
  setClickedRiverString: (value: string) => void;
  isLeftkeyClickRiver: boolean;
  setIsLeftkeyClickRiver: (value: boolean) => void;
  isLeftRiver: boolean;
  setIsLeftRiver: (value: boolean) => void;
  isMinEyeClickRiver: boolean;
  setIsMinEyeClickRiver: (value: boolean) => void;
};

const RiverContext = createContext<RiverContextType | undefined>(undefined);

export const RiverProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [RiverOpenSidebarMap, setRiverOpenSidebarMapState] = useState(
    new Map<string, RiverDetails>()
  );
  const [clickedRiverString, setClickedRiverString] = useState<string | null>(
    null
  );
  const [isLeftkeyClickRiver, setIsLeftkeyClickRiver] = useState(false);
  const [isLeftRiver, setIsLeftRiver] = useState(false);
    const [isMinEyeClickRiver, setIsMinEyeClickRiver] = useState(false);

  const setRiverOpenSidebarMap = (type: string, RiveropenMap: RiverDetails) => {
    setRiverOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(type, RiveropenMap);
      return newMap;
    });
  };

  const removeFromRiverOpenSidebarMap = (sensorId: string) => {
    setRiverOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.delete(sensorId);
      return newMap;
    });
  };

  const clearRiverOpenSidebarMap = () => {
    setRiverOpenSidebarMapState(new Map());
  };

  // Provide the state and the updater functions
  return (
    <RiverContext.Provider
      value={{
        RiverOpenSidebarMap,
        setRiverOpenSidebarMap,
        removeFromRiverOpenSidebarMap,
        clearRiverOpenSidebarMap,
        clickedRiverString,
        setClickedRiverString,
        isLeftkeyClickRiver,
        setIsLeftkeyClickRiver,
        isLeftRiver,
        setIsLeftRiver,
        isMinEyeClickRiver,
        setIsMinEyeClickRiver,
      }}
    >
      {children}
    </RiverContext.Provider>
  );
};

// Custom hook for using RiverContext
export const useRiverContext = () => {
  const context = useContext(RiverContext);
  if (!context) {
    throw new Error("useHzContext must be used within an HzProvider");
  }
  return context;
};
